import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { PwTranslateLoader } from '@pw-translate-loader';
import { CaptchaModule } from '../captcha/captcha.module';
import { ForgotPasswordModalComponent } from './components/forgot-password/forgot-password.component';
import { ForgotPasswordService } from './services/forgot-password/forgot-password.service';

@NgModule({
  declarations: [ForgotPasswordModalComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    TranslateModule,
    CaptchaModule,
  ],
  providers: [MatDialog, ForgotPasswordService, TranslatePipe],
})
export class ForgotPasswordModule {
  constructor(private _translateLoader: PwTranslateLoader) {
    this._translateLoader.addModule({ name: 'forgot_password', relateLocation: 'shared/forgot_password' });
  }
}
